import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom/cjs/react-router-dom'
import images from '../../../../../api/images/hooks'
import { APPLICATION_SETTINGS } from '../../../../../common/constants'
import Loader from '../../../../../Components/Common/Loader'
import { useBlobUrls } from '../../../../../Components/Hooks/useBlobUrl'
import { formatNumberWithTwoDecimals } from '../../../../../utils/general'
import { renderAreaUnit } from '../../../../../utils/property'

const InfoWindowContent = (props) => {
    const { id, propertyType, mainPhoto, propertyService, area, price, city, widerArea, quarter, updated } = props
    const [imageQuery] = images.GetImagesByUrl.useQueries(mainPhoto?.id ? [{ id: mainPhoto.id, updated }] : [], '')
    const blobUrl = useBlobUrls([imageQuery])

    const isLoading = imageQuery?.isPending
    const src = blobUrl[0]

    const { t } = useTranslation()
    const areaUnit = APPLICATION_SETTINGS.AREA_UNIT
    const currency = APPLICATION_SETTINGS.CURRENCY

    return (
        <Link to={`properties/${id}`} className="d-flex mt-2">
            {isLoading ? <Loader /> : <img width="150" height="auto" src={src} alt={mainPhoto?.fileDescription} />}
            <div>
                <p className="fw-bold mb-0 ms-4">
                    {propertyType?.name}, {propertyService?.name}
                </p>
                <p className="mb-3 ms-4">
                    {city?.name}, {quarter?.name ? quarter?.name : widerArea?.name}
                </p>
                <p className="fw-bold mb-1 ms-4">
                    <span className="fw-medium">{t('table.header.profile.price')}:</span> {formatNumberWithTwoDecimals(price)} {currency}
                </p>
                <p className="fw-bold mb-0 ms-4">
                    <span className="fw-medium">{t('app.common.spaceArea')}:</span> {area} {renderAreaUnit(areaUnit)}
                </p>
            </div>
        </Link>
    )
}

export default InfoWindowContent
